import React from 'react'
import Filters from './Filters'
import DemoSidebar from './DemoSidebar'
import DemoTextInfo from './DemoTextInfo'

export default function DemoSearchResult() {
    return (
        <div className='pt-16 flex xl:pr-[4.75rem] lg:flex-row flex-col pb-20'>
            <div className='w-full lg:w-[25%] pr-[3.75rem] border-r-2'>
                <DemoSidebar />
            </div>
            <div className='w-full lg:w-[75%] pl-14'>
                <Filters title="Demographic" />
                <DemoTextInfo />
            </div>
        </div>
    )
}
